export default __webpack_public_path__ + "static/media/for_way5.f1a63382.png";